export default "__VITE_ASSET__DNNkEN_Q__"